import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppContextService, EcaAppShellModule, EcaLeftNavModule, LeftNavLink } from '@drc-eca/eca-components-lib';
import { RouterOutlet } from '@angular/router';
import { AppPermissionsService } from '../services/app-permissions/app-permissions.service';
import { take } from 'rxjs';

@Component({
    selector: 'eca-default-app-shell',
    templateUrl: './default-app-shell.component.html',
    styleUrls: ['./default-app-shell.component.scss'],
    imports: [EcaAppShellModule, RouterOutlet, EcaLeftNavModule]
})
export class DefaultAppShellComponent implements OnInit {
  private appContextService = inject(AppContextService);
  private _appPermissionsService = inject(AppPermissionsService);

  title = 'Security UI';
  token: string;

  links$: LeftNavLink[] = [];

  ngOnInit() {
    this._appPermissionsService.canViewApplication().pipe(take(1)).subscribe((result) => {
      if (result) {
        this.links$ = [
          {
            label: 'Group Management',
            url: 'groups',
            activeStateWhen: {
              regExp: /^\/groups/
            }
          },
          {
            label: 'User Management',
            url: 'users',
            activeStateWhen: {
              regExp: /^\/users/
            }
          }
        ];
      }
    });
    this.appContextService.setSelectedApplicationId(environment.applicationId);
  }

}
